import { Helmet } from "react-helmet";
import { Layout } from "@/components/layout/Layout";

export default function AgentTermsPage() {
  return (
    <Layout>
      <Helmet>
        <title>Agent Agreement | StayMiddle</title>
        <meta name="description" content="Agent Agreement for StayMiddle platform" />
      </Helmet>
      
      <div className="container max-w-4xl py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold mb-8 text-center">StayMiddle Agent Agreement</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-muted-foreground mb-6">
              This agreement governs the relationship between StayMiddle ("Platform") and you ("Agent") 
              for the purpose of generating and sharing custom property booking links on StayMiddle.
            </p>
            
            <p className="text-muted-foreground mb-8">
              By registering as an Agent, you agree to the following terms:
            </p>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">1. Roles and Responsibilities</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You may generate booking links with custom markup to share with clients.</li>
                <li>You are not the owner or legal representative of the properties listed.</li>
                <li>You are responsible for ensuring the accuracy of pricing and markup.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">2. Commissions and Payouts</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You earn a commission based on the markup percentage you apply to each booking.</li>
                <li>Commissions are processed via Stripe Connect and paid to your registered bank account.</li>
                <li>Payouts may be withheld for investigation in case of disputes or misuse.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">3. Confidentiality and Conduct</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You agree not to disclose confidential property or owner details to guests unless necessary.</li>
                <li>You agree to uphold StayMiddle's brand reputation and not engage in misleading behavior.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">4. Booking Terms</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You may not directly collect payment from clients outside the platform.</li>
                <li>Bookings are confirmed only through StayMiddle's payment system.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">5. Termination</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Your account may be suspended or terminated if you breach these terms or misuse the platform.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}